import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { SubTopicsProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const SUB_TOPICS_QUERY = graphql`
query NodeAllSubTopicsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "SubTopics" } }) {
    nodes {
      data
    }
  }
}
`;

export const SubTopicsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(SUB_TOPICS_QUERY), 'items')}>{children}</Provider>;
};
